module.exports = __webpack_public_path__ + "img/profile-2user.c282473e.svg";